import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogTrigger
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { MdEmail } from 'react-icons/md'
import { ContactForm } from './ContactForm'
import { DialogProps } from '@/types/types'
import { cn } from '@/lib/utils'

export function ContactDialog({ labelColor, label }: DialogProps) {
    return (
        <Dialog>
            {/* FIXME: this has some hydration issues. probably because of the button class name or style? */}
            <DialogTrigger asChild>
                {label ? (
                    <Button>
                        <MdEmail size={20} className='mr-2' />
                        {label}
                    </Button>
                ) : (
                    <Button
                        className={cn('px-0 py-0 hover:no-underline', labelColor && `text-${labelColor}`)}
                        variant='link'
                        style={{ color: labelColor }}>
                        <MdEmail size={24} />
                    </Button>
                )}
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle className='text-center my-4'>Kontaktieren Sie uns!</DialogTitle>
                </DialogHeader>
                <DialogDescription asChild>
                    <ContactForm />
                </DialogDescription>
            </DialogContent>
        </Dialog>
    )
}
